/**
 * Append a freshly-dictated chunk to existing text, with sensible spacing.
 * - Trims the incoming chunk
 * - Adds a space between existing text and the new chunk if needed
 */
export function appendVoiceChunk(existing: string, chunk: string): string {
  const trimmed = chunk.trim();
  if (!trimmed) return existing;
  if (!existing) return capitalizeFirst(trimmed);
  const needsSpace = !/\s$/.test(existing) && !/^[.,;:!?]/.test(trimmed);
  return existing + (needsSpace ? " " : "") + trimmed;
}

function capitalizeFirst(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
